<form [formGroup]="formTerms" #formSign>
  <cdk-form-group class="pt-0">
    <label for="Input-contract-term-user-name" class="input-label">Write your user to sign</label>
    <input
      id="Input-contract-term-user-name"
      type="text"
      cdkInput
      placeholder="E.g Jane Doe"
      formControlName="username" />
    <cdk-error *ngIf="formTerms.get('username').hasError('required')"
      >This field is required</cdk-error
    >
    <cdk-error *ngIf="formTerms.get('username').hasError('pattern')"
      >Please insert a valid username</cdk-error
    >
  </cdk-form-group>
</form>
